import { IUserAccountStore } from '../../index'
import { INotificationMarkAsRead } from '../../../../actions/notification/notifications'

export default function(
  store: IUserAccountStore,
  action: INotificationMarkAsRead,
) {
  const notification = store.notifications.items.find(
    not => String(not.id) === String(action.id),
  )

  return {
    ...store,
    notifications: {
      ...store.notifications,
      countNotRead: notification
        ? notification.readAt
          ? store.notifications.countNotRead
          : store.notifications.countNotRead === 0
          ? 0
          : store.notifications.countNotRead - 1
        : store.notifications.countNotRead,
      items: [
        ...store.notifications.items.map(not => {
          if (not.id === action.id) {
            not.readAt = new Date()
          }
          return not
        }),
      ],
    },
  }
}
